import { Timestamp } from '@angular/fire/firestore';

/** Lifecycle of a New Academic Year draft, groups/{id}/academic_year_rollovers/{fromYear} */
export enum RolloverStatus {
  draft = 'draft',
  finalizing = 'finalizing',
  done = 'done',
  failed = 'failed',
}

/** Year-end decision for one student */
export enum RolloverStudentStatus {
  active = 'active',
  alumni = 'alumni',
  removed = 'removed',
}

export interface RolloverNewGrade {
  /** Firestore id the grade will be created with */
  id: string;
  gradeName: string;
  gradeAvgAge: number;
}

export interface RolloverResult {
  message: string;
  errors?: string[];
  archivedStudents?: number;
  promoted?: number;
  alumni?: number;
  removed?: number;
  skipped?: number;
  grades?: number;
}

export interface AcademicYearRollover {
  fromYear: number;
  toYear: number;
  status: RolloverStatus;
  keepGradeIds: string[];
  addGrades: RolloverNewGrade[];
  /** New-year grade id -> teacher uid (null = unassigned) */
  teachers: { [gradeId: string]: string | null };
  createdById?: string;
  lockedById?: string;
  lockExpires?: Timestamp;
  result?: RolloverResult;
  created?: Timestamp;
  modified?: Timestamp;
}

/** groups/{id}/academic_year_rollovers/{fromYear}/students/{uid} */
export interface RolloverStudent {
  memberId: string;
  name?: string;
  photoURL?: string | null;
  fromGradeId?: string | null;
  fromGradeName?: string | null;
  status: RolloverStudentStatus;
  /** New-year grade id; anything not kept or added counts as unassigned */
  newGradeId: string | null;
  /** Leave the student untouched and unarchived */
  skip: boolean;
  modified?: Timestamp;
}

/** Year-end result stored on a school_archives record */
export enum ArchiveOutcome {
  promoted = 'promoted',
  alumni = 'alumni',
}

/** One archived academic year of a student, as returned by school_archives_listForChild */
export interface SchoolArchive {
  id: string;
  groupId: string;
  groupName: string | null;
  memberId: string;
  name: string | null;
  photoURL: string | null;
  academicYear: number;
  gradeId: string | null;
  gradeName: string | null;
  teacherId: string | null;
  teacherName: string | null;
  outcome: ArchiveOutcome;
  nextGradeId: string | null;
}

export interface SchoolArchiveShare {
  groupId: string;
  groupName: string | null;
  /** Epoch millis */
  expiresAt: number | null;
  revoked: boolean;
}
